import { render, staticRenderFns } from "./AddCustomerDialog.vue?vue&type=template&id=53ac4eb2"
import script from "./AddCustomerDialog.vue?vue&type=script&lang=js"
export * from "./AddCustomerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports